import { Entry } from '../Entry'

export function Entry20230322() {
  return (
    <Entry title="March 22 2023 - v3.3.8">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13728/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
